import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const commingSoonCitiesList = (cityData, showLoader = true) => {
  return async (dispatch) => {
    if (showLoader) dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "COMMING_SOON_CITIES_LIST_REQUEST" });

      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/setting/list-comming-soon-cities`,
        axiosConfig
      );

      if (data.statusCode === 200) {
        dispatch({ type: "COMMING_SOON_CITIES_LIST_SUCCESS", payload: data });
        dispatch({ type: "SET_FETCHED_TIME", payload: Date.now() });
      } else {
        dispatch({ type: "COMMING_SOON_CITIES_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "COMMING_SOON_CITIES_LIST_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      if (showLoader) dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const commingSoonCitiesAdd = (cityData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "COMMING_SOON_CITIES_ADD_REQUEST" });

      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/setting/add-comming-soon-cities`,
        cityData,
        axiosConfig
      );

      if (data.statusCode === 200) {
        dispatch({ type: "COMMING_SOON_CITIES_ADD_SUCCESS", payload: data });
        // toast.success("City Added Successfully!");
        return data;
      } else {
        dispatch({ type: "COMMING_SOON_CITIES_ADD_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "COMMING_SOON_CITIES_ADD_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const commingSoonCitiesUpdate = (cityData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "COMMING_SOON_CITIES_UPDATE_REQUEST" });

      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.put(
        `${BASE_URL}/setting/update-comming-soon-cities`,
        cityData,
        axiosConfig
      );

      if (data.statusCode === 200) {
        dispatch({ type: "COMMING_SOON_CITIES_UPDATE_SUCCESS", payload: data });
        // toast.success("City Updated Successfully!");
        return data;
      } else {
        dispatch({ type: "COMMING_SOON_CITIES_UPDATE_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "COMMING_SOON_CITIES_UPDATE_FAIL",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
      return error?.response?.data?.message;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const commingSoonCitiesRemove = (cityData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "COMMING_SOON_CITIES_REMOVE_REQUEST" });

      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
        },
        data: cityData
      };

      const { data } = await axios.delete(
        `${BASE_URL}/setting/delete-comming-soon-city`,
        axiosConfig
      );

      if (data.statusCode === 200) {
        dispatch({ type: "COMMING_SOON_CITIES_REMOVE_SUCCESS", payload: data });
        toast.success("City Removed Successfully!");
        return data;
      } else {
        dispatch({ type: "COMMING_SOON_CITIES_REMOVE_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "COMMING_SOON_CITIES_REMOVE_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
